import React, { useState, useEffect } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Collapse,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableCell,
  TableContainer,
  TableBody,
  TableRow,
  TableHead,
  TextField,
  Typography,
  makeStyles,
  CircularProgress,
  TablePagination,
  Modal,
  Divider,
  Link
} from '@material-ui/core';
import { palette } from '@material-ui/system';
import { toast } from 'react-toastify';
import { IoIosLock, IoMdClose, IoMdFunnel } from 'react-icons/io';
import { useSubscriptionFilter, useSubscriptions } from './hooks';
import { TableFooter } from 'semantic-ui-react';
import { InvoiceModalContainer, LoadingOverlay } from './styles';
import swal from 'sweetalert';
import { producaov2 } from '../../../../services/apis';
import { getUSER } from '../../../../services/auth';
import { normalizeSubscriptionsFilters } from './utils';

const useFilterStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  formControl: {
    width: '100%',
    minWidth: 120,
  },
}));


export function SubscriptionsFilters({
  defaultFilters,
  onChangeFilters,
  onClearAllFilters
}) {
  const filters = useSubscriptionFilter(defaultFilters);

  const classes = useFilterStyles();

  const onSubmitFilters = (e) => {
    e?.preventDefault();

    onChangeFilters(filters.filters);
  }

  const onClearFilters = () => {
    onClearAllFilters();
  }
  
  return (
    <form onSubmit={onSubmitFilters}>
      <Accordion>
        <AccordionSummary>
          <Grid container alignItems="center" spacing={1}>
            <Grid item alignItems="center">
              <IoMdFunnel />
            </Grid>
            <Grid item>
              <Typography>Filtro</Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={4}>
            <Grid item container spacing={3}>
              <Grid item container spacing={6}>
                <Grid item xs={6}>
                  <TextField  
                    className={classes.formControl}
                    label="Aluno"
                    placeholder="Insira o nome ou email"
                    value={filters?.filters?.user}
                    onChange={e => filters.changeFilter('user', e.target.value)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    className={classes.formControl}
                    label="Plano"
                    placeholder="Insira o nome do Plano"
                    value={filters?.filters?.plan}
                    onChange={e => filters.changeFilter('plan', e.target.value)}
                  />  
                </Grid>
              </Grid>
              <Grid item container spacing={6}>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Status Faturas</InputLabel>
                    <Select
                      value={filters?.filters?.status}
                      onChange={e => filters.changeFilter('status', e.target.value)}
                    >
                      <MenuItem value=""><em>Nenhum</em></MenuItem>
                      <MenuItem value="paid">Pago</MenuItem>
                      <MenuItem value="pending">Pendente</MenuItem>
                      <MenuItem value="canceled">Estornado</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Vencimento</InputLabel>
                    <Select
                      value={filters?.filters?.dueDateType}
                      onChange={e => filters.changeFilter('dueDateType', e.target.value)}
                    >
                      <MenuItem value=""><em>Nenhum</em></MenuItem>
                      <MenuItem value="today">Vence hoje</MenuItem>
                      <MenuItem value="tomorrow">Vence amanhã</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item container spacing={6}>
                <Grid item xs={6}>
                  <FormControl className={classes.formControl}>
                    <InputLabel>Forma de pagamento</InputLabel>
                    <Select
                      value={filters?.filters?.payment_method}
                      onChange={e => filters.changeFilter('payment_method', e.target.value)}
                    >
                      <MenuItem value=""><em>Todos</em></MenuItem>
                      <MenuItem value="credit_card">Cartão de Crédito</MenuItem>
                      <MenuItem value="boleto">Boleto</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item container alignItems="center" justifyContent="flex-end" spacing={3}>
              <Grid item>
                <Button type="button" onClick={onClearFilters} color="secondary" startIcon={<IoMdClose size="0.8em" />} variant="outlined">Limpar filtros</Button>
              </Grid>
              <Grid item>
                <Button type="submit" color="primary" variant="contained">Aplicar filtros</Button>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </form>
  );
}

function SubscriptionStatusBadge({ subscription }) {
  const status = subscription?.status;

  if (status === 'canceled_admin') {
    const cancellation = subscription?.adminCancellation;
    const tooltip = cancellation
      ? `Cancelada pelo admin em ${cancellation.canceledAt}${cancellation.description ? ` — ${cancellation.description}` : ''}`
      : 'Cancelada pelo admin';

    return (
      <Box
        padding="0.5rem 1rem"
        borderRadius="10rem"
        bgcolor="error.main"
        color="#FFF"
        component="span"
        style={{ whiteSpace: 'nowrap' }}
        title={tooltip}
      >
        Cancelada (admin)
      </Box>
    );
  }

  if (status === 'canceled') {
    return (
      <Box
        padding="0.5rem 1rem"
        borderRadius="10rem"
        border={1}
        borderColor="error.main"
        color="error.main"
        component="span"
      >
        Cancelada
      </Box>
    );
  }

  if (status === 'active') {
    return (
      <Box
        padding="0.5rem 1rem"
        borderRadius="10rem"
        bgcolor="success.main"
        color="#FFF"
        component="span"
      >
        Ativa
      </Box>
    );
  }

  return (
    <Box
      padding="0.5rem 1rem"
      borderRadius="10rem"
      border={1}
      borderColor="grey.500"
      color="text.secondary"
      component="span"
      style={{ whiteSpace: 'nowrap' }}
      title="Assinatura sem status local definido (não ativada ou registro antigo)"
    >
      Não ativada
    </Box>
  );
}

function SubscriptionsTableRow({subscription, onPaidUpdate, refreshData}) {
  const [isOpenInvoices, setIsOpenInvoices] = useState(false);
  const [loadingRetry, setLoadingRetry] = useState(false);

  const handlePaidUpdate = (invoiceID) => {
    onPaidUpdate(invoiceID);
  }

  const handleRetryCharges = async () => {
    try {
      setLoadingRetry(true);

      const response = await producaov2.get(`/subscriptions/${subscription.id}/retry-invoices`);

      refreshData();

      const failedInvoices = response.data?.failedInvoices || 0;

      const modalText = failedInvoices > 0
        ? `Ainda há ${failedInvoices} faturas com falha`
        : 'Todas as faturas foram pagas';

      swal('Relatório das cobranças', modalText, 'success');
    } catch(error) {
      toast.error('Houve um erro ao recobrar as faturas');
    } finally {
      setLoadingRetry(false);
    }
  }

  return (
    <>
      <TableRow>
        <TableCell>{subscription?.orderID}</TableCell>
        <TableCell>{subscription?.user?.name}</TableCell>
        <TableCell>{subscription?.id}</TableCell>
        <TableCell>{subscription?.paymentMethod}</TableCell>
        <TableCell>{subscription?.plan?.name}</TableCell>
        <TableCell>
          <SubscriptionStatusBadge subscription={subscription} />
        </TableCell>
        <TableCell>
          <Box
            padding="0.5rem 1rem"
            borderRadius="10rem"
            bgcolor={subscription?.hasPendingInvoices ? "error.main" : "success.main"}
            color="#FFF"
            component="span"
          >
            {subscription?.hasPendingInvoices ? 'Sim' : 'Não'}
          </Box>
        </TableCell>
        <TableCell>
          <Box
            padding="0.5rem 1rem"
            borderRadius="10rem"
            border={1}
            borderColor={subscription?.hasCanceledInvoices ? "error.main" : "success.main"}
            color={subscription?.hasCanceledInvoices ? "error.main" : "success.main"}
            component="span"
          >
            {subscription?.hasCanceledInvoices ? 'Sim' : 'Não'}
          </Box>
        </TableCell>
        <TableCell>
          {subscription?.hasBlockedContent ? (
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
              <IoIosLock size="1.25em" />
              SIM
            </span>
          ) : 'Não'}
        </TableCell>
        <TableCell>
          <Button
            variant="text"
            color="primary"
            onClick={() => setIsOpenInvoices(prev => !prev)}
          >
            {`${subscription?.invoices?.length || 0} Faturas`}
          </Button>
        </TableCell>
        <TableCell>
          {subscription?.hasPendingInvoices && subscription?.paymentMethod === 'credit_card' && (
            <Button
              variant="outlined"
              color="primary"
              size="small"
              disabled={loadingRetry}
              onClick={handleRetryCharges}
            >
              {loadingRetry ? 'Recobrando...' : 'Retentar Cobranças'}
            </Button>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11}>
          <Collapse in={isOpenInvoices}>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">Faturas</Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Ciclo</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="center">Data Cobrança</TableCell>
                    <TableCell align="center">Data Pagamento</TableCell>
                    <TableCell>Forma Pagamento</TableCell>
                    <TableCell align="center">Próxima Fatura</TableCell>
                    <TableCell>Observação</TableCell>
                    <TableCell align="center">Data Vencimento</TableCell>
                    <TableCell>Boleto</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subscription?.invoices?.map(invoice => {
                    return (
                      <TableRow>
                        <TableCell>{invoice?.id}</TableCell>
                        <TableCell>{invoice?.cycle}</TableCell>
                        <TableCell>{invoice?.status}</TableCell>
                        <TableCell align="center">{invoice?.billingDate}</TableCell>
                        <TableCell align="center">{invoice?.paymentDate}</TableCell>
                        <TableCell>{invoice?.paymentMethod}</TableCell>
                        <TableCell align="center">{invoice?.nextInvoiceDate}</TableCell>
                        <TableCell>{invoice?.notes}</TableCell>
                        <TableCell align="center">{invoice?.boleto?.dueAt}</TableCell>
                        <TableCell style={{ maxWidth: '240px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                          <a
                            href={invoice?.boleto?.pdf}
                            target="_blank"
                          >
                            {invoice?.boleto?.pdf}
                          </a>
                        </TableCell>
                        <TableCell>
                          {(invoice?.status !== 'paid') && (
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              type="button"
                              onClick={() => handlePaidUpdate(invoice?.id)}
                            >
                              Atualizar com Pago
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}

const useTableStyles = makeStyles((theme) => ({
  tableBody: {
    position: 'relative'
  },
  formControl: {
    width: "100%",
  },
  divider: {
    marginBottom: '1rem'
  },
  formGrid: {
    width: '100%'
  }
}));

function InvoiceUpdateModal({ selectedInvoiceID, onClose, onSubmit }) {
  const classes = useTableStyles();

  const [paymentMethod, setPaymentMethod] = useState("");
  const [notes, setNotes] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    if(!paymentMethod) {
      return alert("Informe um método de pagamento");
    }

    if(!notes) {
      return alert("Informe uma observação");
    }

    try {
      setIsLoading(true);

      await producaov2.put(`fatura/${selectedInvoiceID}/payment`, { paymentMethod, observation: notes });
      swal("Sucesso", "Fatura atualizada com sucesso", "success");

      onSubmit();
    } catch(error) {
      console.log(error);
      swal("Erro", "Ocorreu um erro ao atualizar a fatura", "error");
    } finally {
      setIsLoading(false);
    }

    onSubmit({paymentMethod, notes});
  }

  return (
    <Modal open={!!selectedInvoiceID} onClose={onClose}>
      <InvoiceModalContainer onSubmit={handleSubmit}>
        <Box
          bgcolor="#FFF"
          padding={4}
          width="600px"
        >
          <Typography variant="h6">{`Fatura: ${selectedInvoiceID}`}</Typography>
          <Divider className={classes.divider} />
          <Grid container spacing={3} className={classes.formGrid}>
            <Grid item xs={12}>
              <TextField
                className={classes.formControl}
                label="Método de Pagamento"
                placeholder="Insira o método de pagamento"
                value={paymentMethod}
                onChange={e => setPaymentMethod(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                className={classes.formControl}
                label="Observação"
                value={notes}
                onChange={e => setNotes(e.target.value)}
              />
            </Grid>
          </Grid>
          <Box marginTop={4}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="outlined" color="secondary" type="button" onClick={onClose}>
                  Cancelar
                </Button>
              </Grid>
              <Grid item>
                <Button disabled={isLoading} variant="contained" color="primary" type="submit">
                  {isLoading ? 'Atualizando ...' : 'Atualizar'}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </InvoiceModalContainer>
    </Modal>
  )
}

export function SubscriptionsTable({ filters }) {
  const classes = useTableStyles();

  const {data, page, rowsPerPage, isLoading, changePage, changeRowsPerPage, refreshData} = useSubscriptions({filters});

  const [selectedInvoiceID, setSelectedInvoiceID] = useState(null);

  const subscriptions = data.data;

  const handleChangePage = (event, newPage) => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    changePage(newPage);
  }

  const handleChangeRowPerPage = (event) => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    changeRowsPerPage(parseInt(event.target.value, 10));
    changePage(0);
  }

  const onCloseInvoiceUpdateModal = () => {
    setSelectedInvoiceID(null);
  }

  const onSubmitInvoiceUpdate = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    refreshData();
    onCloseInvoiceUpdateModal();
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID Pedido</TableCell>
              <TableCell>Aluno</TableCell>
              <TableCell>ID Assinatura</TableCell>
              <TableCell>Forma de Pagamento</TableCell>
              <TableCell>Plano</TableCell>
              <TableCell>Status Assinatura</TableCell>
              <TableCell>Possui Faturas Pendentes?</TableCell>
              <TableCell>Possui Faturas Estornadas?</TableCell>
              <TableCell>Conteúdo Bloqueado?</TableCell>
              <TableCell align="right">
                <Typography variant="body2">
                  {isLoading ? <CircularProgress size={24} /> : `${data?.paging?.total || '-'} Assinaturas`}
                </Typography>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {subscriptions?.map(subscription => {
              return <SubscriptionsTableRow key={subscription?.id} subscription={subscription} onPaidUpdate={setSelectedInvoiceID} refreshData={refreshData} />
            })}
            {isLoading && <LoadingOverlay />}
          </TableBody>
          <TableFooter>
            <TablePagination
              rowsPerPageOptions={[15, 30, 60, 200]}
              count={data?.paging?.total || 1}
              page={page}
              rowsPerPage={rowsPerPage}
              onChangePage={handleChangePage}
              onRowsPerPageChange={handleChangeRowPerPage}
            />
          </TableFooter>
        </Table>
      </TableContainer>
      <InvoiceUpdateModal
        key={selectedInvoiceID}
        selectedInvoiceID={selectedInvoiceID}
        onClose={onCloseInvoiceUpdateModal}
        onSubmit={onSubmitInvoiceUpdate}
      />
    </>
  );
}

export function SubscriptionsActions({ filters }) {
  const [isLoadingMail, setIsLoadingMail] = useState(false);
  const [hasSentEmail, setHasSentMail] = useState(true);
  const [reportUrl, setReportUrl] = useState('');
  const [loadingReport, setLoadingReport] = useState(false);

  useEffect(() => {
    const checkHasSentMail = async () => {
      try {
        await producaov2.get('/faturas/logs/send-emails');
        setHasSentMail(true);
      } catch(error) {
        setHasSentMail(false);
      }
    }

    checkHasSentMail();
  }, []);

  const handleGenerateReport = async () => {
    setLoadingReport(true);

    const normalizedFilters = normalizeSubscriptionsFilters(filters);

    try {
      const response = await producaov2.post('/admin/reports/invoices', {
        email: getUSER().email,
        ...normalizedFilters,
      });
  
      setReportUrl(response.data.url);
    } catch(e) {
      toast.error('Houve um erro ao gerar o relatório');
      console.log(e);
    } finally {
      setLoadingReport(false);
    }
  }

  const handleSendMail = async () => {
    setIsLoadingMail(true);

    try {
      const response = await api.post('/faturas/send-mail-pre-charge');

      const emailSend = response.data.body.actions.filter(a => !!a.sendMail)
      swal("Sucesso", `${emailSend.length} email enviados`, "success");
    } catch(error) {
      console.log(error);
      swal('Erro', 'Houve um erro ao enviar o email diario', 'error');
    }
  }
  
  return (
    <Grid container spacing={4} justifyContent="flex-end">
      <Grid item>
        <Button variant="outlined" color="secondary" disabled={hasSentEmail || isLoadingMail} onClick={handleSendMail}>
          {hasSentEmail ? 'Email diário já enviado' : (isLoadingMail ? 'Enviando ...' : 'Enviar email diário')}
        </Button>
      </Grid>
      <Grid item>
        {!reportUrl 
          ? (
            <Button variant="contained" color="primary" disabled={loadingReport} onClick={handleGenerateReport}>
              {loadingReport ? 'Gerando relatório ...' : 'Gerar relatório'}
            </Button>
          ) : (
            <Button
              variant="outlined"
              color="primary"
              component={Link}
              href={reportUrl}
              onClick={() => setReportUrl('')}
            >
              Baixar relatorio
            </Button>
          )
        }
      </Grid>
    </Grid>
  );
}